import { Injectable } from '@angular/core';
import { HttpHeaders, HttpResponse } from '@angular/common/http';

import { ServiceResponse } from "@common/data-models/service/service-response";
import { NomWebServicesJson } from "@common/services/nom-web-services-json";
import { ServiceCollectionRecord } from '@common/data-models/service/service-collection-record';
import { ApiServiceCollectionRecord } from '@common/data-models/service/api-service-collection-record';
import { DataStore } from "@common/data-models/data-store/data-store";
import { RecordFactory } from "@common/data-models/records/record-factory";
import { Util } from "@common/utils/util";
import { ObjectProperties } from "@common/data-models/service/object-properties";

import { TopicRecord } from "@playbook/data-models/records/topic-record";
import { AssignmentRecord } from "@playbook/data-models/records/assignment-record";
import { TopicTemplateRecord } from "@playbook/data-models/records/topic-template-record";
import { ObjectTypes } from "@common/enums/object-types";
import { PublicationListRecord } from '../data-models/records/publication-list-record';

@Injectable({ providedIn: 'root' })
export class PublicationService {
    constructor(
        public nomWebServicesJson: NomWebServicesJson
    ) {
    }

    public async publishPublicationList(database: string, path: string, copyFromId: string, copyFromPath: string, linkToParent: boolean, fields: { [id: string]: any }): Promise<ServiceResponse<PublicationListRecord>> {
        let response: HttpResponse<any> = null;
        if (fields) {
            Util.escapeSpecialCharsForFileName(fields)
            fields["CreatedBy"] = "CreatedBy." + this.nomWebServicesJson.UserId
        }
        try {
            let requestParams = {
                database: database,
                path: path,
                dateTime: "",
                user: this.nomWebServicesJson.UserId,
                fieldsToUpdate: this.nomWebServicesJson.Convertor.toENPSFields(fields),
                templateGuid: copyFromId,
                templateProgramId: copyFromPath,
                linkToParent: linkToParent
            }
            response = await this.nomWebServicesJson.put(
                "/api/Publication", 
                requestParams, {
                headers: new HttpHeaders({
                    "Content-Type": "application/json",
                    "X-ENPS-TOKEN": this.nomWebServicesJson.NomTokenId
                }),
                responseType: 'json',
                observe: 'response'
            });
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: "Unable to publish",
                detailMessage: `Unable to publish. \n\rStackTrace: PublicationService.publishPublicationList(); \n\rError: ${error}`
            });
            return new ServiceResponse<PublicationListRecord>(false, "Unable to create topic " + error.toString());
        }
        let serviceRecord = ServiceCollectionRecord.instance(response.body);
        serviceRecord.instantiateChildren();

        let publicationRecord = this.nomWebServicesJson.Convertor.fromServiceCollectionRecord<PublicationListRecord>(serviceRecord);
        await DataStore.setCollection(publicationRecord, true);
        return new ServiceResponse<PublicationListRecord>(true, DataStore.byGuid<PublicationListRecord>(publicationRecord.guid, null));
    }
}
